import { render, staticRenderFns } from "./MetalSnapMaterialEdit.vue?vue&type=template&id=38e74480&"
import script from "./MetalSnapMaterialEdit.vue?vue&type=script&lang=js&"
export * from "./MetalSnapMaterialEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports